import React,{Component} from 'react';
import "./style.less";
import {NavBar,Toast,ListView,Icon} from "antd-mobile";
import {connect} from "react-redux";
import {getOrderList} from "../../../service/homeService";
let pageIndex = 1;
let pageSize = 10;
const dataError = require('../../../common/image/wrongData.png');
const black = require('../../../common/image/black.png');
const noOrder = require('../../../common/image//noOrder.png');
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class ReplaceOrderList extends Component{
    constructor(props) {
        super(props);
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });
        this.state = {
            OrderListData:[],
            dataSource,
            isLoading: true,
            notDataLoading:0,
        }
    };
    componentDidMount() {
        pageIndex = 1;
        let params={
            token: this.props.userInfo.token,
            data:{
                pageSize: pageSize,
                pageNum: 1
            }
        };
       this._getOrderList(params);
    }
    _getOrderList(params){
        getOrderList(params).then((res) => {
                if(res.data.code == "0000"){
                    console.log(res)
                    if (res.data.data.list.length > 0) {
                        this._setDataSource(res.data.data);
                        // this.setState({data:res.data.data.list})
                    }else{
                        this.setState({isLoading: false,notDataLoading:1});
                    }
                }else {
                    this.setState({notDataLoading:2,isLoading: false});
                    Toast.info(res.data.msg,3)
                }
            }).catch(function (error) {
            console.log(error);
        });
    };
     //数据拼接
     _setDataSource(data) {
        const allData = [...this.state.OrderListData, ...data.list];
        this.setState({
            dataSource:this.state.dataSource.cloneWithRows(allData),
            OrderListData: allData,
        });
        if (pageIndex * pageSize >= data.total) {
            this.setState({isLoading: false});
        }
    }
    //上拉加载
    _onEndReached = () => {
        if (this.state.isLoading) {
            let params = {
                token: this.props.userInfo.token,
                data:{
                    pageSize: pageSize,
                    pageNum: ++pageIndex
                },
            };
            this._getOrderList(params);
        }
    };
    notData(){
        if(this.state.notDataLoading == 1){
            return <div className="noData">
                        <img src={noOrder} />
                        <p>暂无代下单记录</p>
                    </div>
        }else if(this.state.notDataLoading == 2){
            return <div className="noData">
                <img src={dataError} />
                <p>数据出错，请稍后再试！</p>
            </div>
        }else{
            return null
        }
    }
    goPage = (e,k,j) => {
        //改签
        if(j == 'SelectShift'){
            e.stopPropagation();
            this.props.history.push('/SelectShift',
            {
                startCity:k.startCity,
                endCity:k.endCity,
                startPosition:k.startPosition,
                endPosition:k.endPosition,
                id:k.id,
                startAddress:k.startAddress,
                endAddress:k.endAddress,
                lineIds: [
                    {
                        "endStationId":k.endStationId,
                        "lineId":k.lineId,
                        "startStationId": k.startStationId
                    }
                ]
        
            })
        }
        //退款
        if(j == 'refundTicket'){
            e.stopPropagation();
            this.props.history.push('/refundTicket',{id:k.id})
        }
        //改签订单详情
        if(j == 'ReplaceOrderInfo'){
            e.stopPropagation();
            this.props.history.push('/ReplaceOrderInfo',{id:k.id})
        }
        //退款详情
        if(j == 'RefundApply'){
            e.stopPropagation();
            this.props.history.push('/RefundApply',{id:k.id})
        }
        //支付页面
        if(j == 'payDetail'){
            e.stopPropagation();
            console.log(k.id)
            // return
            this.props.history.push('/payDetail',{
                orderNum:k.id,//传订单id到支付页面
                seatNum:k.seatNum,
                totalPrice:k.price,
                type:0,//0是正常支付，1是改签，2是发票
            })
        }
    };
    btnStatus(res,k){
        if(res == 6){//状态 4:待付款 6:未出行 8:行程中 10:取消 11:已完成 9:已改签 12:已退票
            return <div><button onClick={(e)=>this.goPage(e,k,'refundTicket')}>退款</button>
                    <button onClick={(e)=>this.goPage(e,k,'SelectShift')}>改签</button></div>
        }
        if(res == 4){
            return <div><button className="payBtn"  onClick={(e)=>this.goPage(e,k,'payDetail')}>支付</button></div>
        }
        if(res == 9){
            // return <div><button onClick={()=>this.props.history.push('/ReplaceOrderInfo',{id:k.id})}>改签订单</button></div>
            return <div><button onClick={(e)=>this.goPage(e,k,'ReplaceOrderInfo')}>改签订单</button></div>
        }
        if(res == 12){
            return <div><button onClick={(e)=>this.goPage(e,k,'RefundApply')}>退款详情</button></div>
        }
    };
    status(res){
        if(res == 6){//状态 4:待付款 6:未出行 8:行程中 10:取消 11:已完成 12:已改签 13:已退票
            return '未出行'
        }
        if(res == 4){
            return '待付款'
        }
        if(res == 8){
            return '行程中'
        }
        if(res == 10){
            return '已取消'
        }
        if(res == 11){
            return '已完成'
        }
        if(res == 9){
            return '已改签'
        }
        if(res == 12){
            return '已退票'
        }
    }
    render(){
        const _renderRow = (i, index, rowID) => (
            <div className="list" key={rowID} onClick={()=>this.props.history.push('/ReplaceOrderInfo',{id:i.id,status:i.status,data:i,lineIds: [
                {
                    "endStationId":i.endStationId,
                    "lineId":i.lineId,
                    "startStationId": i.startStationId
                }
            ]})}>
                <div className="top">
                    <span>订单号  {i.orderNum}</span>
                    <span>{this.status(i.status)}</span>
                </div>
                <div className="middle">
                    <div className="body">
                        <div>{i.startCity}</div>
                        <div>
                            <div>{i.startDate} {i.weekend} {i.startTime}</div>
                            <img src={black}/>
                        </div>
                        <div>{i.endCity}</div>
                    </div>
                    <p>当前出行位置<span>{i.seatNum}</span><span className="pic">￥{i.price}</span></p>
                </div>
                <div className="bottom">
                    {this.btnStatus(i.status,i)}
                </div>
            </div>
        )
        return(
            <div className="replaceOrderList">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()} />}
                >代下单记录</NavBar>
                <div className="content">
                    {this.notData()}
                    {
                        this.state.notDataLoading == 0  ?
                            <ListView
                                ref={el => this.lv = el}
                                dataSource={this.state.dataSource}
                                renderFooter={() => (this.state.isLoading ? <Icon type="loading"/> : '没有更多')}
                                renderRow={_renderRow}
                                style={{
                                    height: '100%',
                                    overflow:'auto'
                                }}
                                onEndReached={this._onEndReached.bind(this)}
                                scrollRenderAheadDistance={300}
                                onEndReachedThreshold={30}
                            />: null
                    }        
                           
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Member/ReplaceOrderList/index.js